module.exports = __webpack_public_path__ + "img/gzh.2c77fca6.jpg";